import { AfterViewInit, ChangeDetectionStrategy, Component, OnChanges, OnInit, ViewChild, ChangeDetectorRef, Input } from '@angular/core';
import { StringPropertyViewModel } from '../../../../../lib/view-models/base-type/string-property-view-model';
import { BaseExternalPropertyTextBox } from '../base-external-property-text-box';
import { StringTextBoxComponent } from '../string-text-box/string-text-box.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import type { ExternalViewModelInterface } from '@nts/std/interfaces';

@UntilDestroy()
@Component({
    selector: 'nts-ext-string-text-box',
    templateUrl: './ext-string-text-box.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        StringTextBoxComponent
    ]
})
export class ExtStringTextBoxComponent extends BaseExternalPropertyTextBox<string> implements OnInit, OnChanges, AfterViewInit {

    @Input() showErrorTooltip = true;
    @Input() showErrorBorder = true;

    @ViewChild(StringTextBoxComponent, { static: true }) stringTextBox: StringTextBoxComponent;

    override propertyViewModel: StringPropertyViewModel;
    override externalPropertyViewModel: ExternalViewModelInterface;

    get input() {
        return this.stringTextBox.input;
    }

    get inputValue() {
        return this.stringTextBox.inputValue;
    }

    constructor(cd: ChangeDetectorRef) {
        super(cd);
    }

    untilDestroyedThis(): <U>(source: Observable<U>) => Observable<U> {
        return untilDestroyed<this>(this);
    }

    ngOnInit() {
        if (!this.propertyViewModel) { throw new Error('Missing viewModel!'); }
        if (!this.externalPropertyViewModel) { throw new Error('Missing viewModel!'); }

    }

    ngAfterViewInit(): void {
        this.init();
    }

    showErroTooltip(): void {
        this.stringTextBox.showErroTooltip();
    }
}
